// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only. Unauthorized use,
// copying, or distribution is prohibited and may be prosecuted.

import StationQueue from './StationQueue'

/**
 * Ready & Out queue — filled prescriptions awaiting handoff.
 *
 * Bundles three states post-fill:
 *  - `dispensed`         Ready at the counter for pickup
 *  - `out_for_delivery`  In transit with a courier
 *  - `delivered`         Completed; kept in this queue briefly for
 *                        confirmation/return handling
 *
 * U-03 (PharmacyTech): "I want one queue that shows me what's at the
 * window and what's in the van." This is that queue.
 */
export default function ReadyAndOutTab() {
  return (
    <StationQueue
      states="dispensed,out_for_delivery,delivered"
      tabKey="ready"
      title="Ready & out"
      subtitle="Filled prescriptions waiting at the counter or in transit."
      emptyMessage="Nothing ready for pickup or out for delivery."
    />
  )
}
